import { Channel, UserBlocking } from '@dinosband/bv-main-schema/dist/types'
import { Store as MainStore } from '@dinosband/bv-main-client'
import { BvApolloClient } from '@dinosband/bv-main-client'

import { BvDataCenterContext, SubscriptionManager } from '..'

import { ChatRooms } from './chat-room'
import { User_ChatRoomViews } from './user_chat-room-view'
import { ChatRoomMessages } from './message'
import { MyJobOfferResponses, MyJobOffers } from './job-offer'
import { ChatRoomQueryFilters } from './filter'
import { Profiles } from './profile/profiles'
import { ChannelExperts } from './channel'
import { MyJobReviews } from './job-offer/my-job-reviews'

interface _DATA_CENTER_MEMBER_TYPE {
  init(): Promise<void>
  cleanup(): void
  onReconnected?: () => void
}


export class BvDataCenter {

  context: BvDataCenterContext

  chatRooms: ChatRooms
  userViews: User_ChatRoomViews
  myJobOffers: MyJobOffers
  myJobOfferResponses: MyJobOfferResponses
  myJobReviews: MyJobReviews
  messages: ChatRoomMessages
  filters: ChatRoomQueryFilters

  profiles: Profiles
  channelExperts: ChannelExperts

  _managers: _DATA_CENTER_MEMBER_TYPE[] = []
  _managers2: _DATA_CENTER_MEMBER_TYPE[] = []

  private _mainClientSubscriptions = new SubscriptionManager()

  constructor (messengerClient: BvApolloClient) {
    const context = new BvDataCenterContext(messengerClient)
    context.dataCenter = this
    this.context = context
    this.chatRooms = new ChatRooms(context)
    this.userViews = new User_ChatRoomViews(context)
    this.myJobOffers = new MyJobOffers(context)
    this.myJobOfferResponses = new MyJobOfferResponses(context)
    this.myJobReviews = new MyJobReviews(context)
    this.messages = new ChatRoomMessages(context)
    this.filters = new ChatRoomQueryFilters(context)
    this.profiles = new Profiles(context)
    this.channelExperts = new ChannelExperts(context)

    this._managers = [
      this.chatRooms,
      this.messages,
      this.userViews,
      this.myJobOffers,
      this.myJobOfferResponses,
      this.myJobReviews,
      this.profiles,
      this.channelExperts,
      // this.jobOfferResponses,
    ]
    messengerClient.onReconnected(() => { this.onReconnected() })
  }

  get mainStore () { return this.context.mainStore }
  set mainStore (mainStore: MainStore) { this.context.mainStore = mainStore }

  get limit () { return this.context.limit }
  set limit (limit: { chatRoomIds: number[] } | undefined) { this.context.limit = limit }

  initialized = false

  async init () {
    const mainStore = this.context.mainStore
    if (!mainStore.userId || mainStore.userId <= 0) {
      return
    }
    await Promise.all(this._managers.map((i) => i.init()))
    await Promise.all(this._managers2.map((i) => i.init()))
    this.initSubscriptions()
    this.initialized = true
  }

  cleanup () {
    this._managers2.forEach((i) => i.cleanup())
    this._managers.forEach((i) => i.cleanup())
    this.cleanupSubscriptions()
    this.initialized = false
  }

  chatRoom (chatRoomId: number) {
    return this.chatRooms.chatRoom(chatRoomId)
  }

  get privateChatRooms () {
    return this.chatRooms.privateChatRooms
  }

  get helpDeskChatRooms () {
    return this.chatRooms.helpDeskChatRooms
  }

  async readChatRoom (chatRoomId: number) {
    return this.chatRoom(chatRoomId) ?? await this.chatRooms.readChatRoom(chatRoomId)
  }

  // jobOfferResponse (jobOfferId: number): JobOfferResponse | undefined {
  //   return this.jobOfferResponses.responses[jobOfferId]
  // }

  // async waitJobOffer (messageId: number, timeout = 5000) {
  //   return await this.jobOffers.wait(messageId, timeout)
  // }

  async initChannelChatRooms (channel: Channel) {
    if (!this.context.mainStore?.userId) {
      return
    }
    const chatRoomIds = await this.chatRooms.initChannelChatRooms(channel)
    if (chatRoomIds?.length) {
      await this.messages.initChatRooms(chatRoomIds, channel.id)
    }
  }

  cleanupChannelChatRooms (channelId: number) {
    this.messages.cleanupChannel(channelId)
    this.chatRooms.cleanupChannelChatRooms(channelId)
  }

  private onReconnected () {
    if (!this.initialized) {
      return
    }
    this._managers.forEach((i) => { if (i.onReconnected) { i.onReconnected() } })
    this._managers2.forEach((i) => { if (i.onReconnected) { i.onReconnected() } })
  }

  private initSubscriptions () {
    const mainStore = this.context.mainStore
    this._mainClientSubscriptions.init(mainStore.watch)
    this._mainClientSubscriptions.subscribe(mainStore.USER_BLOCKING_CHANGED, async (data?: { added: UserBlocking, deleted: UserBlocking}) => {
      await this.messages.lastMessages.updateLastMessages('channel-chat-rooms')
    })
  }

  private cleanupSubscriptions () {
    this._mainClientSubscriptions.cleanup()
  }

}